import React, { useRef, useState, useEffect } from 'react'
import styled, { withTheme } from 'styled-components'
import is from 'styled-is'

import Icon from './Icon'
import Action from './Action'

const Title = styled.p`
  font-weight: 800;
`

const List = styled.ul`
  display: grid;
  list-style-type: none;
  padding: 0px;
`

const ListItem = styled.li`
  display: flex;
  border-top: 1px solid ${(props) => props.theme.colors.lightGray};
  border-bottom: 1px solid ${(props) => props.theme.colors.lightGray};
  margin: 0px -28px;
  padding: 0px 28px;

  ${is('order')`
    order: ${(props) => props.order}
  `};
`

const ListActions = styled.span`
  margin-left: auto;
  justify-content: center;
  margin-top: auto;
  margin-bottom: auto;
`

export const ActionSpacing = styled.span`
  padding: 0px 10px;
`

export const ListViewItem = ({ name, children, order }) => {
  const ref = useRef()

  return (
    <ListItem ref={ref} order={order}>
      <p>{name}</p>
      <ListActions>{children}</ListActions>
    </ListItem>
  )
}

const Nav = styled.span`
  display: flex;

  justify-content: flex-end;
  align-items: center;
  margin-top: 32px;
`
const NavAction = withTheme(({ name, active, onClick, theme }) => {
  return (
    <div>
      <ActionSpacing />
      {active ? (
        <Action onClick={() => onClick()}>
          <Icon bordered={false} small name={name} />
        </Action>
      ) : (
        <Icon bordered={false} small name={name} color={theme.colors.gray} />
      )}
    </div>
  )
})

const NavBar = ({
  childrenCount,
  itemsPerPage,
  navigatePage,
  buttonEnum,
  currentPage,
  maxPages,
}) => {
  return (
    <Nav>
      <Title>
        {currentPage * itemsPerPage + 1} -{` `}
        {(currentPage + 1) * itemsPerPage > childrenCount
          ? childrenCount
          : (currentPage + 1) * itemsPerPage}
        {` `}
        von {childrenCount}
      </Title>
      <NavAction
        onClick={() => navigatePage(buttonEnum.First)}
        name="chevron-left"
        active={currentPage > 0}
      />
      <NavAction
        onClick={() => navigatePage(buttonEnum.Previous)}
        name="chevron-left"
        active={currentPage > 0}
      />
      <NavAction
        onClick={() => navigatePage(buttonEnum.Next)}
        name="arrow-right"
        active={currentPage < maxPages}
      />
      <NavAction
        onClick={() => navigatePage(buttonEnum.Last)}
        name="arrow-right"
        active={currentPage < maxPages}
      />
    </Nav>
  )
}

const ListView = ({ children, title, itemsPerPage, itemCount }) => {
  const BtnEnum = { First: 1, Previous: 2, Next: 3, Last: 4 }
  const [currentPage, setCurrentPage] = useState(0)
  const maxPages = Math.floor((itemCount - 1) / itemsPerPage)
  const [shownItemIndex, setShownItemIndex] = useState({ start: 0, end: 0 })

  useEffect(() => {
    setShownItemIndex({
      start: currentPage * itemsPerPage,
      end: (currentPage + 1) * itemsPerPage,
    })
  }, [currentPage, itemsPerPage])

  const navPage = (btn) => {
    let tempCurrentPage = currentPage
    switch (btn) {
      case BtnEnum.First:
        tempCurrentPage = 0
        break
      case BtnEnum.Previous:
        tempCurrentPage = currentPage - 1
        break
      case BtnEnum.Next:
        tempCurrentPage = currentPage + 1
        break
      case BtnEnum.Last:
        tempCurrentPage = maxPages
        break
    }
    setShownItemIndex({
      start: tempCurrentPage * itemsPerPage,
      end: (tempCurrentPage + 1) * itemsPerPage,
    })
    setCurrentPage(tempCurrentPage)
  }

  return (
    <div>
      <NavBar
        currentPage={currentPage}
        maxPages={maxPages}
        buttonEnum={BtnEnum}
        navigatePage={navPage}
        childrenCount={itemCount}
        itemsPerPage={itemsPerPage}
      />
      <Title>{title}</Title>
      <List>{children({ shownItemIndex })}</List>
      <NavBar
        currentPage={currentPage}
        maxPages={maxPages}
        buttonEnum={BtnEnum}
        navigatePage={navPage}
        childrenCount={itemCount}
        itemsPerPage={itemsPerPage}
      />
    </div>
  )
}

export default withTheme(ListView)
